<template>
	<div class="wangEditor">
		<div  v-if="showEditor" placeholder="请输入内容" ref="editor"></div>
	</div>
</template>

<script>
  import E from 'wangeditor'
  export default {
    name: 'index',
    data() {
      return {
        accept: 'image/gif, image/jpeg, image/png, image/jpg',
        replyCategoryForm: {
          content: '',
          selectType: '1'
        },
        exportUrl: '',
        showEditor: true,
        editor: null,
        answerOnlyPic: false
      }
    },
    methods: {
      /**
       * 初始化编辑器
       * */
      initEditor(data) {
        let editor = new E(this.$refs.editor)
        this.editor = editor
        editor.customConfig.menus = [
          'head',
          'bold',
          'foreColor',
          'italic',
          'underline',
          'list',
          'justify',
          'image',
          'link',
        ]
        let _that = this
        editor.customConfig.linkImgCallback = function (url) {
          _that.answerOnlyPic = true
        }
        editor.customConfig.customUploadImg = function (files, insert) {
          let img = files[0]
          let type = img.type
          let size = img.size
          if (_that.accept.indexOf(type) == -1) {
            _that.$message({
              showClose: true,
              message: '图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          if (size > 5242880) {
            _that.$message({
              showClose: true,
              message: '请选择5M以内的图片！',
              type: 'error',
              duration: 3 * 1000
            })
            return false
          }
          let formdata = new FormData()
          formdata.set('file', img)
          _that.$http.uploadImageAPI(formdata).then(res => {
            if (res.status == 1) {
              _that.answerOnlyPic = true
              insert(res.data)
            }
          })
          // files 是 input 中选中的文件列表
          // insert 是获取图片 url 后，插入到编辑器的方法

        }
        editor.customConfig.onblur = function (html) {
          // html 即编辑器中的内容
          // console.log('onblur', html)
          if (_that.editor.txt.text() == '') {
            _that.$emit('editorBlurEvent', '')
          } else {
            _that.$emit('editorBlurEvent', html)
          }
        }
        editor.create()

        editor.txt.html(data)
      }
    },
    mounted() {
      this.initEditor()
    }
  }
</script>

<style scoped>

</style>